module.exports = __webpack_public_path__ + "img/thropy-selesai.774eab37.svg";